import { useState } from "react";

export const NavigationComponent = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div className={"tesapp-component"}>
        <div className={"tesapp-navigation"}>
          <div className={"tesapp-navigation-branding"}>
            <a href={"/"}>
              <img
                src={"/logo-temnography.png"}
                alt={"Logo Temnography®"}
                width={100}
                className={"tesapp-branding-logo"}
              />
            </a>
          </div>

          {/* Standardowe menu na desktop */}
          <div className={"tesapp-navigation-elementor"}>
            <ul className={"tesapp-el-builder"}>
              <li><a href={"/news"}><b>Aktualności</b></a></li>
              <li><a href={"#jak-to-dziala"}>Jak to działa?</a></li>
              <li><a href={"#zalety"}>Zalety z korzystania</a></li>
              <li><a href={"#wersje-produktu"}>Wersje produktu</a></li>
              <li><a href={"#dystrybutor"}>Dystrybucja</a></li>
            </ul>
          </div>

          {/* Przycisk Hamburgera (widoczny tylko na mobile) */}
          <div className={"tesapp-hamburger-btn"} onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        {/* Pełnoekranowe menu mobilne */}
        <div className={`tesapp-mobile-menu ${isOpen ? "active" : ""}`}>
          <div className={"tesapp-mobile-menu-header"}>
            <img
              src={"/logo-temnography.png"}
              alt={"Logo Temnography®"}
              width={100}
            />
            <button className={"tesapp-close-btn"} onClick={toggleMenu}>
              &times;
            </button>
          </div>
          <ul className={"tesapp-mobile-el-builder"}>
            <li><a href={"/news"} onClick={toggleMenu}><b>Aktualności</b></a></li>
            <li><a href={"#jak-to-dziala"} onClick={toggleMenu}>Jak to działa?</a></li>
            <li><a href={"#zalety"} onClick={toggleMenu}>Zalety z korzystania</a></li>
            <li><a href={"#wersje-produktu"} onClick={toggleMenu}>Wersje produktu</a></li>
            <li><a href={"#dystrybutor"} onClick={toggleMenu}>Dystrybucja</a></li>
          </ul>
        </div>

        <div className={"tesapp-present"}>
          <div className={"tesapp-present-content"}>
            <h1 className={"tesapp-f-title"}>TEMNOGRAPHY<span className={"tesapp-trademark"}>®</span></h1>
            <h1 className={"tesapp-f-subtitle"}>New horizon of diagnostic</h1>
            <br/>
            <p className={"tesapp-text"} style={{fontWeight: 500}}>
              Pomaga lekarzom ratować więcej istnień ludzkich i zmniejszać liczbę niepełnosprawności.
            </p><br/><br/>
            <a href={"#jak-to-dziala"} className={"tesapp-btn btn-desktop"}>Dowiedz się więcej</a>
            <a href={"#jak-to-dziala"} className={"tesapp-btn btn-mobile"}>Dowiedz się więcej</a>
          </div>
        </div>
      </div>
    </>
  );
};